import React from 'react';
import Svg, { Path } from 'react-native-svg';
var SVGComponent = function SVGComponent(props) {
  var style = props.style;
  return /*#__PURE__*/React.createElement(Svg, {
    viewBox: "0 0 1024 1024",
    width: "14",
    height: "14",
    style: style
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M270.4 214.4C336 160 420 128 512 128c212 0 384 172 384 384h64c0-247.2-200.8-448-448-448-107.2 0-205.6 37.6-282.4 100l40.8 50.4z",
    "p-id": "2715",
    fill: "#ffffff"
  }));
};
export default SVGComponent;